// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"59fa972347722764","8232":"017f26169a69c680"}[chunkId] + ".css";
};